export interface SameTileStackOffset {
  x: number;
  y: number;
  z: number;
}

export interface SameTileStackLayoutOptions {
  verticalStep?: number;
  maxRadius?: number;
  radialStep?: number;
  stackClearanceForPlayer?: (playerId: string) => number | null | undefined;
}

const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5));
const DEFAULT_VERTICAL_STEP = 0.28;
const DEFAULT_MAX_RADIUS = 0.16;
const DEFAULT_RADIAL_STEP = 0.08;

export function computeSameTileStackOffset(
  orderedOccupantIds: readonly string[],
  playerId: string,
  options: SameTileStackLayoutOptions = {},
): SameTileStackOffset {
  const stackIndex = orderedOccupantIds.indexOf(playerId);
  if (stackIndex <= 0) return { x: 0, y: 0, z: 0 };

  const verticalStep = options.verticalStep ?? DEFAULT_VERTICAL_STEP;
  const maxRadius = options.maxRadius ?? DEFAULT_MAX_RADIUS;
  const radialStep = options.radialStep ?? DEFAULT_RADIAL_STEP;
  const angle = stackIndex * GOLDEN_ANGLE;
  const radius = Math.min(maxRadius, radialStep * stackIndex);
  let y = 0;
  for (let index = 0; index < stackIndex; index += 1) {
    const occupantId = orderedOccupantIds[index];
    if (occupantId == null) continue;
    const clearance = options.stackClearanceForPlayer?.(occupantId);
    y +=
      clearance != null && Number.isFinite(clearance) && clearance > 0 ? clearance : verticalStep;
  }

  return {
    x: Math.cos(angle) * radius,
    y,
    z: Math.sin(angle) * radius,
  };
}
